import {
  GridColumnMenuFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";

export function ColumnMenu(props: GridColumnMenuProps) {
  return (
    <div>
      <GridColumnMenuFilter {...props} expanded />
    </div>
  );
}
